import config from 'config';
import * as http from 'utils/http';
import serialize from 'utils/serialize';

const endpoints = {
  journey_logs: (id) => `${config.API_URL}mercury/journeys/${id}/logs/`,
  shipper_order_logs: (id) => `${config.API_URL}mercury/shipper_orders/${id}/logs/`,
  itinerary_logs: (id) => `${config.API_URL}itineraries/${id}/logs/`,
  journey_log_edit: (journeyId, logId) =>
    `${config.API_URL}mercury/journeys/${journeyId}/logs/${logId}/`,
  shipper_order_log_edit: (shipperOrderId, logId) =>
    `${config.API_URL}mercury/shipper_orders/${shipperOrderId}/logs/${logId}/`,
  journey_log_resolve: (journeyId, logId) =>
    `${config.API_URL}mercury/journeys/${journeyId}/logs/${logId}/resolve/`,
  shipper_order_log_resolve: (shipperOrderId, logId) =>
    `${config.API_URL}mercury/shipper_orders/${shipperOrderId}/logs/${logId}/resolve/`,
};

const getJourneyLogRequest = async (journeyId, params) => {
  return await http.get(`${endpoints.journey_logs(journeyId)}?${serialize(params)}`);
};

const getItineraryLogRequest = async (journeyId, params) => {
  return await http.get(`${endpoints.itinerary_logs(journeyId)}?${serialize(params)}`);
};

const getShipperOrderLogRequest = async (shipperOrderId, params) => {
  return await http.get(`${endpoints.shipper_order_logs(shipperOrderId)}?${serialize(params)}`);
};

const createJourneyLogRequest = async (journeyId, log) => {
  return await http.post(endpoints.journey_logs(journeyId), {
    ...log,
  });
};

const createShipperOrderLogRequest = async (shipperOrderId, log) => {
  return await http.post(endpoints.shipper_order_logs(shipperOrderId), {
    ...log,
  });
};

const updateJourneyLogRequest = async (journeyId, logId, log = {}) => {
  return await http.patch(endpoints.journey_log_edit(journeyId, logId), log);
};

const updateShipperOrderLogRequest = async (shipperOrderId, logId, log = {}) => {
  return await http.patch(endpoints.shipper_order_log_edit(shipperOrderId, logId), log);
};

const resolveJourneyLogRequest = async (journeyId, logId) => {
  return await http.put(endpoints.journey_log_resolve(journeyId, logId));
};

const resolverShipperOrderLogRequest = async (shipperOrderId, logId) => {
  return await http.put(endpoints.shipper_order_log_resolve(shipperOrderId, logId));
};

// Workers
const getEndpoint =
  ({ itineraryId, journeyId, shipperOrderId }) =>
  (journeyEndpoint, shipperOrderEndpoint, itineraryEndpoint) => {
    if (itineraryId) {
      return async (...vars) => await itineraryEndpoint(itineraryId, ...vars);
    }

    if (!journeyId && !shipperOrderId) {
      return null;
    }

    if (journeyId) {
      return async (...vars) => await journeyEndpoint(journeyId, ...vars);
    }

    if (shipperOrderId) {
      return async (...vars) => await shipperOrderEndpoint(shipperOrderId, ...vars);
    }

    return null;
  };

export {
  getJourneyLogRequest,
  getShipperOrderLogRequest,
  getItineraryLogRequest,
  createJourneyLogRequest,
  createShipperOrderLogRequest,
  updateJourneyLogRequest,
  updateShipperOrderLogRequest,
  resolveJourneyLogRequest,
  resolverShipperOrderLogRequest,
  getEndpoint,
};
